/* eslint-disable no-extra-bind */
const PictViewClass = require('pict-view');

class DocumentCurrent extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.CurrentDocumentCloneAction = 'Duplicate';
		this.AvailableCloneForms = [];
		this.AvailableCloneFormsWithMaps = [];
	}

	onBeforeRenderAsync(pCallback)
	{
		if (!this.AppData?.DocumentData)
		{
			this.log.warn('No document data found.');
		}
		else
		{
			this.CurrentDocumentData = this.AppData.DocumentData;
		}

		if (pCallback) pCallback();
	}

	async onAfterRenderAsync(pCallback)
	{
		if (pCallback) pCallback();
	}

	/**
	 * Download the PDF for the selected Document
	 * @param {object} event - The click event
	 */
	handleDocumentDownload(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			const element = event.target;
			// set the button to be loading
			element.classList.add('is-loading');

			// download the pdf
			this.pict.providers.DocumentProvider.handleDocumentDownload(false, this.AppData?.DocumentData?.ReportData, () =>
			{
				element.classList.remove('is-loading');
			});
		}
	}

	/**
	 * A callback to run when the user confirms the cloning of data into a new form type. This will clone all data from the current form into a new form of a different type.
	 * @param {*} event - the click event
	 */
	confirmCloneCallback(event)
	{
		if (event)
		{
			event.target.classList.add('is-loading');
		}
		// the custom options for the clone
		const customOptions = {};
		// fetch the custom title for the cloned document
		const newDocumentTitle = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-Title');
		// set the new document title in case it was changed
		customOptions.Name = newDocumentTitle;
		//set window Target based on call from mobile device or desktop
		const windowTarget = this.pict.providers.DocumentProvider.isOpenDocumentCalledFromMobileDevice() ? '_top' : '_blank';

		const tmpAnticipate = this.fable.newAnticipate();
		const tmpCloneData = {};
		let abandonClone = false;

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				if (this.CurrentDocumentCloneAction === 'Workflow')
				{
					// fetch the clone rules record from the server
					const tmpSelectedMapValue = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map');
					if (tmpSelectedMapValue)
					{
						this.pict.EntityProvider.getEntitySetPage('ManifestSchema', `FBV~Type~EQ~Clone~FBV~Hash~EQ~${tmpSelectedMapValue}`, 0, 10,
						function(pError, pRecords)
						{
							if (pError)
							{
								this.log.error('Error fetching cloning map manifest schema:', pError);
								fCallback();
							}
							else if (pRecords && pRecords.length > 0)
							{
								if (pRecords.length > 1)
								{
									this.log.warn('Multiple cloning map manifest schemas found, using the first one.');
								}
								else
								{
									this.log.info('Applying cloning map manifest schema:', pRecords[0]);
								}
								tmpCloneData.CloneRulesManifest = pRecords[0];
								fCallback();
							}
							else
							{
								// set this flag to skip the cloning process
								abandonClone = true;
								this.log.warn('No cloning map manifest schema found, skipping cloning map application.');
								const tmpDisplayName = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map');
								// show toast notification
								// custom body content
								document.getElementById('CloneDocumentModalBody').innerHTML =
								/*html*/`
								<div class="container column is-12">
									<p class="title is-5 has-text-centered p-2 mb-5">
										<span class="icon">
											<i class="fa fa-fw fa-circle-check has-text-danger"></i>
										</span>
										<span> Form data failed to clone.</span>
									</p>
									<p class="subtitle is-6 has-text-centered">The form workflow named <strong>${ tmpDisplayName }</strong> did not have a valid cloning map defined. Please check the workflow settings and try again.</p>
									<p class="subtitle is-6 has-text-centered">Please click button below to close this modal.</p>
								</div>`;
								// custom footer content
								document.getElementById('CloneDocumentModalFooter').innerHTML =
								/*html*/`
								<button class="button is-link" type="button" title="Close modal" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
									<span class="icon">
										<i class="fas fa-fw fa-check" aria-hidden="true"></i>
									</span>
									<span>Close</span>
								</button>`;
								fCallback();
							}
						}.bind(this));
					}
					else
					{
						this.log.info('No cloning map selected, skipping cloning map application.');
						fCallback();
					}
				}
				else
				{
					fCallback();
				}
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				if (this.CurrentDocumentCloneAction === 'Workflow' && tmpCloneData.CloneRulesManifest)
				{
					// create a new document record to clone to
					tmpCloneData.NewDocumentCloneRecord = tmpCloneData?.CloneRulesManifest?.Manifest?.DocumentPayload || {};
					// set the document type to the selected form type
					if (!('FormData' in tmpCloneData?.NewDocumentCloneRecord))
					{
						tmpCloneData.NewDocumentCloneRecord.FormData = {};
					}
					tmpCloneData.NewDocumentCloneRecord.FormData.SourceRecordFormData = this.pict.AppData.DocumentData.ReportData.FormData || {};

					if (!('Descriptors' in tmpCloneData?.CloneRulesManifest?.Manifest))
					{
						tmpCloneData.CloneRulesManifest.Manifest.Descriptors = {};
					}
					// map the data from the current document to the new document based on the cloning map
					const tempDescriptorKeys = Object.keys(tmpCloneData.CloneRulesManifest.Manifest.Descriptors);
					tempDescriptorKeys.forEach(function(pDescriptorKey)
					{
						const tmpDescriptor = tmpCloneData.CloneRulesManifest.Manifest.Descriptors[pDescriptorKey];
						if (tmpDescriptor.hasOwnProperty('ToAddress'))
						{
							this.pict.manifest.setValueAtAddress(tmpCloneData.NewDocumentCloneRecord.FormData, tmpDescriptor.ToAddress, this.pict.manifest.getValueAtAddress(_Pict.AppData.DocumentData.ReportData.FormData, pDescriptorKey));
						}
					}.bind(this));
					// set the document date to now
					tmpCloneData.NewDocumentCloneRecord.DocumentDate = new Date().toISOString();
					// set the name to the new document title
					tmpCloneData.NewDocumentCloneRecord.Name = newDocumentTitle || tmpCloneData?.CloneRulesManifest?.Manifest?.NewDocumentName;
					// set the document project from the cloned document
					tmpCloneData.NewDocumentCloneRecord.IDProject = this.AppData.DocumentData.ReportData.IDProject;
				}
				fCallback();
			}.bind(this));

		// for the non-workflow cloning actions, set up the new document record accordingly
		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				if (this.CurrentDocumentCloneAction === 'Duplicate' || this.CurrentDocumentCloneAction === 'Clone')
				{
					tmpCloneData.NewDocumentCloneRecord = {
						Form: 1,
					};
					// create a new document record to clone to
					tmpCloneData.NewDocumentCloneRecord.FormData = Object.assign({}, this.pict.AppData.DocumentData.ReportData.FormData);
					// set the document date to now
					tmpCloneData.NewDocumentCloneRecord.DocumentDate = new Date().toISOString();
					// set the name to the new document title
					tmpCloneData.NewDocumentCloneRecord.Name = newDocumentTitle;
					// set the document project from the cloned document
					tmpCloneData.NewDocumentCloneRecord.IDProject = this.AppData.DocumentData.ReportData.IDProject;
					// set the document type to the selected form type
					if (this.CurrentDocumentCloneAction === 'Duplicate')
					{
						tmpCloneData.NewDocumentCloneRecord.DocumentType = this.pict.AppData.DocumentData.ReportData.DocumentType;
					}
					else
					{
						// TODO: This needs to take the doc type and actually go fetch the RNI Hash (see Document Provider "handleDocumentDuplication()" for reference)
						//		 however, we're punting this feature for now until we discuss how to best implement this so we don't just orphan a buncha FormData on new docs.

						// const tmpSelectedFormType = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-New-Form-Type');
						// if (tmpSelectedFormType)
						// {
						// 	tmpCloneData.NewDocumentCloneRecord.DocumentType = tmpSelectedFormType;
						// }
					}
				}
				fCallback();
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				this.pict.HeadlightRestClient.postJSON(`Document`, tmpCloneData.NewDocumentCloneRecord,
					function(pError, pResponse)
					{
						if (pError)
						{
							this.log.error('Error cloning document data:', pError);
						}
						else
						{
							this.log.info('Document data cloned successfully:', pResponse);
						}
						tmpCloneData.CreatedDocument = pResponse;
						fCallback();
					}.bind(this));
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				// custom body content
				document.getElementById('CloneDocumentModalBody').innerHTML =
				/*html*/`
				<div class="container column is-12">
					<p class="title is-5 has-text-centered p-2 mb-5">
						<span class="icon">
							<i class="fa fa-fw fa-circle-check has-text-success"></i>
						</span>
						<span> Form data successfully cloned.</span>
					</p>
					<p class="subtitle is-6 has-text-centered">A new document titled <strong>${ newDocumentTitle }</strong> has been created with all previously selected data from the original <strong>${ this.AppData.DocumentData.ReportData.Name }</strong> document.</p>
					<p class="subtitle is-6 has-text-centered">Please click button below to open your new document or close this modal.</p>
				</div>`;
				// custom footer content
				document.getElementById('CloneDocumentModalFooter').innerHTML =
				/*html*/`
				<button class="button is-link is-soft" type="button" title="Close modal" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Close</span>
				</button>
				<button class="button is-link" type="button" title="Open new document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, ${tmpCloneData.CreatedDocument.IDDocument}, '${windowTarget}');_Pict.fable.services.HeadlightModal.dismissModals();">
					<span class="icon">
						<i class="fas fa-fw fa-external-link-alt" aria-hidden="true"></i>
					</span>
					<span>Open New Document</span>
				</button>`;

				fCallback();
			}.bind(this));

		tmpAnticipate.wait(
			function(pError)
			{
				if (pError)
				{
					this.log.error('Error during anticipation wait:', pError);
				}
				if (event)
				{
					event.target.classList.remove('is-loading');
				}
			}.bind(this));
	};

	/**
	 * Clone the Form for the selected Document into a new form type
	 */
	cloneDataFromForm()
	{
		// filter out the forms that are designed to accept cloned data with a map
		this.AvailableCloneFormsWithMaps = this.collectAllFormsWithCloneActions();
		this.CurrentDocumentCloneAction = 'Duplicate';
		// the body and footer templates for the duplication modal
		const cloneModalBodyTemplate = /*html*/`
		<span id="CloneDocumentModalBody">
			<div class="column is-12">
				<label class="label">Clone Action</label>
				<div class="field">
					<div class="control">
						<div class="control">
							<div class="select is-fullwidth">
								<select id="CLONE-FOR-DocumentDetails-Document-Clone-Action" onchange="_Pict.views.DocumentCurrent.onCloneFormTypeChange(event, event.target.value)">
									<option value="Duplicate" selected>Duplicate this form</option>
									<option value="Workflow">Workflow to new form</option>
									<!-- IN DEVELOPMENT FEATURE: Hidden for future use <option value="Clone">Clone data to new form</option> -->
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">Current Document</label>
					<div class="control">
						<input id="CLONE-FOR-DocumentDetails-Document-Current-Header-Title" disabled="disabled" class="input" type="text" placeholder="Document Title" value="${this.AppData?.DocumentData?.ReportData?.Name}">
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field" id="CloneDocument-DuplicateSelectField">
					<label class="label">New Document Type</label>
					<div class="control">
						<input id="CLONE-FOR-DocumentDetails-Document-Current-Header-Title" disabled="disabled" class="input" type="text" placeholder="Document Title" value="${this.AppData?.DocumentData?.ReportData?.Name}">
					</div>
				</div>
				<div class="field is-hidden" id="CloneDocument-WorkflowSelectField">
					<!-- Workflow-based cloning -->
					<label class="label">New Document Type from Workflow</label>
					<div id="CloneDocument-WorkflowSelectField-Available" class="control ${ this.AvailableCloneFormsWithMaps.length > 0 ? '' : 'is-hidden' }">
						<div class="select is-fullwidth">
							<select id="CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map" onchange="_Pict.views.DocumentCurrent.onCloneFormTypeChange(event, 'Workflow')">
								${ this.AvailableCloneFormsWithMaps.map((form) => `<option value="${form.Default}">${form.Name}</option>`).join('') }
							</select>
						</div>
					</div>
					<!-- Show a disabled input if there are no available workflows -->
					<div id="CloneDocument-WorkflowSelectField-Empty" class="control ${ this.AvailableCloneFormsWithMaps.length === 0 ? '' : 'is-hidden' }">
						<input class="input" type="text" placeholder="No Available Workflows" disabled="disabled" value="No Available Workflows">
					</div>
				</div>
				<div class="field is-hidden" id="CloneDocument-CloneSelectField">
					<label class="label">New Document Type with Cloned Data</label>
					<div class="control">
						<div class="select is-fullwidth">
							<select id="CLONE-FOR-DocumentDetails-Document-Header-New-Form-Type" onchange="_Pict.views.DocumentCurrent.onCloneFormTypeChange(event, 'Clone')">
								${ this.AvailableCloneForms.map((form) => `<option value="${form.IDReportNamedInstance}" ${form.Hash === this.AppData.DocumentData.ReportData.DocumentType ? 'selected' : ''}>${form.Name}</option>`).join('') }
							</select>
						</div>
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">New Document Title</label>
					<div class="control">
						<input id="CLONE-FOR-DocumentDetails-Document-Header-Title" class="input" type="text" placeholder="Document Title" value="${this.AppData.DocumentData.ReportData.Name} (copy)">
					</div>
				</div>
			</div>
		</span>`;
		const cloneModalFooterTemplate = /*html*/`
		<div id="CloneDocumentModalFooter" class="buttons is-right">
			<button id="CloneDocument-CancelButton" class="button is-link is-soft" type="button" title="Cancel Cloning" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button id="CloneDocument-ConfirmationButton" class="button is-link" type="button" title="Clone Document" onclick="_Pict.views.DocumentCurrent.confirmCloneCallback(event)">
				<span class="icon">
					<i class="fas fa-fw fa-clone" aria-hidden="true"></i>
				</span>
				<span>Clone Document</span>
			</button>
		</div>`;
		// the options for the duplication modal
		const duplicationModalOptions = {
			title: 'Clone Data To New Form',
			modalBodyTemplate: cloneModalBodyTemplate,
			modalFooterTemplate: cloneModalFooterTemplate,
			confirmText: 'Clone Data',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(duplicationModalOptions, this.confirmCloneCallback.bind(this));
	}

	/**
	 * Handle the change event from the form type select to update the document title with the selected form name.
	 * @param {*} event - the change event from the form type select
	 * @param {string} pCloneType - the type of cloning being performed ('Duplicate' 'Workflow', or 'Clone')
	 */
	async onCloneFormTypeChange(event, pCloneType)
	{
		if (event && event.target instanceof HTMLSelectElement)
		{
			const tmpCloneType = pCloneType || event.target.value;

			// hide all three fields initially
			document.getElementById('CloneDocument-WorkflowSelectField').classList.add('is-hidden');
			document.getElementById('CloneDocument-CloneSelectField').classList.add('is-hidden');
			document.getElementById('CloneDocument-DuplicateSelectField').classList.add('is-hidden');
			this.CurrentDocumentCloneAction = tmpCloneType;

			// enable the clone button in case it was disabled previously
			document.getElementById('CloneDocument-ConfirmationButton').removeAttribute('disabled');
			document.getElementById('CloneDocument-ConfirmationButton').removeAttribute('title');
			document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Title').removeAttribute('disabled');

			let displayFormName = '';

			// show the appropriate field based on the selected clone type
			switch (tmpCloneType)
			{
			case 'Duplicate':
				document.getElementById('CloneDocument-DuplicateSelectField').classList.remove('is-hidden');
				displayFormName = this.pict.AppData.DocumentData.ReportData.Name + ' (copy)';
				this.pict.ContentAssignment.assignContent('#CLONE-FOR-DocumentDetails-Document-Header-Title', displayFormName);
				setTimeout(() => $('#CLONE-FOR-DocumentDetails-Document-Header-Title').trigger('focus').trigger('select'), 100);
				break;
			case 'Workflow':
				// show the workflow select field
				const workflowMapElement = document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map');
				const workflowMap = (workflowMapElement instanceof HTMLSelectElement) ? workflowMapElement.selectedOptions?.[0]?.label : undefined;
				if (workflowMap)
				{
					document.getElementById('CloneDocument-WorkflowSelectField').classList.remove('is-hidden');
					if (workflowMap === 'No Available Workflows')
					{
						document.getElementById('CloneDocument-ConfirmationButton').setAttribute('disabled', 'true');
						document.getElementById('CloneDocument-ConfirmationButton').setAttribute('title', 'Cloning not available');
						document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Title').setAttribute('disabled', 'true');
						document.getElementById('CloneDocument-WorkflowSelectField-Empty').classList.remove('is-hidden');
						document.getElementById('CloneDocument-WorkflowSelectField-Available').classList.add('is-hidden');
						return;
					}
					// show the available workflow select field
					document.getElementById('CloneDocument-WorkflowSelectField-Available').classList.remove('is-hidden');
					document.getElementById('CloneDocument-WorkflowSelectField-Empty').classList.add('is-hidden');
					// set the document title to the selected form name and highlight it for easy editing
					displayFormName = workflowMap + ' (with workflow data)';
					this.pict.ContentAssignment.assignContent('#CLONE-FOR-DocumentDetails-Document-Header-Title', displayFormName);
					setTimeout(() => $('#CLONE-FOR-DocumentDetails-Document-Header-Title').trigger('focus').trigger('select'), 100);
				}
				break;
			// NOTE: This feature is currently not active in the UI, but the code is left here for future use.
			case 'Clone':
				// fetch the available forms for cloning
				this.AvailableCloneForms = await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.pict.AppData?.DocumentData?.ReportData?.IDCustomer).catch((error) =>
				{
					this.log.error('Error fetching available forms for cloning:', error);
					document.getElementById('CloneDocument-ConfirmationButton').setAttribute('disabled', 'true');
					document.getElementById('CloneDocument-ConfirmationButton').setAttribute('title', 'Cloning not available');
					document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Title').setAttribute('disabled', 'true');
					return [];
				});
				// filter out any non-forms because we can only clone into forms
				this.AvailableCloneForms = this.AvailableCloneForms.filter((document) => document?.Options?.FormOnly);
				// show the clone select field
				const cloneSelectElement = document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-New-Form-Type');
				const cloneSelectedForm = (cloneSelectElement instanceof HTMLSelectElement) ? cloneSelectElement.selectedOptions?.[0]?.label : undefined;
				if (cloneSelectedForm)
				{
					document.getElementById('CloneDocument-CloneSelectField').classList.remove('is-hidden');
					displayFormName = cloneSelectedForm + ' (with cloned data)';
					this.pict.ContentAssignment.assignContent('#CLONE-FOR-DocumentDetails-Document-Header-Title', displayFormName);
					setTimeout(() => $('#CLONE-FOR-DocumentDetails-Document-Header-Title').trigger('focus').trigger('select'), 100);
				}
				break;
			default:
				this.log.warn(`Unknown clone type selected: ${tmpCloneType}`);
			}
		}
	}

	/**
	 * Collect all forms with CloneAction input types from the PictFormMetacontroller manifest
	 * @returns {Array} - An array of form descriptors with CloneAction input types
	 */
	collectAllFormsWithCloneActions()
	{
		const tmpDescriptors = this.pict.views.PictFormMetacontroller?.manifestDescription?.Descriptors || {};
		const tmpDescriptorsKeys = Object.keys(tmpDescriptors);
		const tmpDescritporsWithCloneActions = [];
		// iterate through all descriptors to find forms with CloneAction input types
		tmpDescriptorsKeys.forEach((descriptorKey) =>
		{
			const descriptor = tmpDescriptors[descriptorKey];
			if (descriptor?.PictForm)
			{
				const hasCloneAction = descriptor?.PictForm?.InputType === 'CloneAction';
				if (hasCloneAction)
				{
					tmpDescritporsWithCloneActions.push(descriptor);
				}
			}
		});
		return tmpDescritporsWithCloneActions;
	}
}

module.exports = DocumentCurrent;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentCurrent',
	DefaultRenderable: 'DocumentCurrent',
	DefaultDestinationAddress: '#DocumentCurrent-Container',
	Templates:
		[
			{
				Hash: 'DocumentCurrent',
				Template: /*html*/`
				<div id="DocumentCurrent-Container" class="container"  style="min-width: 33vw;" data-document-id="{~D:Context[0].CurrentDocumentData.IDDocument~}">
					{~TIfAbs:DocumentCurrent-Empty:Context[0].CurrentDocumentData:Context[0].CurrentDocumentData^==^0~}
					{~TIfAbs:DocumentCurrent-Content:Context[0].CurrentDocumentData:Context[0].CurrentDocumentData^>^0~}
				</div>`,
			},
			{
				Hash: 'DocumentCurrent-Content',
				Template: /*html*/`
				<div class="columns px-5 pt-4 pb-2 mb-0 has-background-text-15">
					<div class="column">
						<p class="title is-4 has-text-white">{~D:Record.ReportData.Name~}</p>
						<p class="subtitle is-6 has-text-text-65">
							<span class="is-pulled-right">
								{~TIfAbs:DocumentCurrent-Locked:Record.ReportData.Locked:Record.ReportData.Locked^==^1~}
								{~TIfAbs:DocumentCurrent-Unlocked:Record.ReportData.Locked:Record.ReportData.Locked^==^0~}
							</span>
							<span class="mr-1">#{~D:Record.ReportData.IDDocument~}</span>
							<span class="mr-1 is-size-7">Form #{~D:Record.ReportData.SequenceNumber~}</span>
						</p>
					</div>
				</div>
				<div class="columns px-5 mt-3">
					<div class="column is-12">
						<span class="title is-block is-6 has-text-text-60">Project</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:Project^Record.ReportData.IDProject^DocumentCurrent-Content-Project^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.ReportData.CreatingIDUser^DocumentCurrent-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Document Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.ReportData.DocumentDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.ReportData.UpdatingIDUser^DocumentCurrent-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update on</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.ReportData.UpdateDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Document Type</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.TidingsData.Type~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Timezone</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Timezone~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Status</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Status~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Observations</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Observations.length~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Work Shift</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Shift~}</span>
					</div>
				</div>
				<div class="buttons is-right py-2 px-5">
					<button id="DocumentCurrent-CloneButton" class="button is-primary {~Show:Record.ReportData.Form~}" type="button" title="View document" onclick="_Pict.views.DocumentCurrent.cloneDataFromForm()">
						<span class="icon">
							<i class="fas fa-fw fa-clone" aria-hidden="true"></i>
						</span>
						<span>Clone Data To New Form</span>
					</button>
					<button class="button is-primary" type="button" title="Download document PDF" onclick="_Pict.views.DocumentCurrent.handleDocumentDownload(event)">
						<span class="icon">
							<i class="fas fa-fw fa-file-pdf" aria-hidden="true"></i>
						</span>
						<span>Download PDF</span>
					</button>
				</div>`,
			},
			{
				Hash: 'DocumentCurrent-Content-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'DocumentCurrent-Content-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'DocumentCurrent-Locked',
				Template: /*html*/`
					<span class="icon has-text-text-95">
						<i class="fas fa-fw fa-sm fa-lock"></i>
					</span>
					<span class="icon-text has-text-text-95">Locked</span>`,
			},
			{
				Hash: 'DocumentCurrent-Unlocked',
				Template: /*html*/`
					<span class="icon">
						<i class="fas fa-fw fa-sm fa-unlock"></i>
					</span>
					<span class="icon-text">Unlocked</span>`,
			},
			{
				Hash: 'DocumentCurrent-Empty',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSet-Empty-Message" class="notification has-text-text-light is-dark m-3">
					<p class="title is-5 has-text-white has-text-centered">No Document Selected</p>
					<p class="subtitle is-6 has-text-text-65 has-text-centered">Please select a record to set as the current document.</p>
				</div>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'DocumentCurrent',
				TemplateHash: 'DocumentCurrent',
				DestinationAddress: '#DocumentCurrent-Container',
				RenderType: 'replace',
			},
		],
};
